import { useEffect, useRef } from "react";
import styles from "./index.module.scss";
import type { OwnProps } from "./types";

const ProspectCardIFrame = ({
  setIframeLoading,
  src
}: OwnProps): JSX.Element => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  const loadingListener = (): void => {
    setIframeLoading(false);
  };

  useEffect(() => {
    const iframeElement = iframeRef.current;
    iframeElement?.addEventListener("load", loadingListener);

    return (): void => {
      iframeElement?.removeEventListener("load", loadingListener);
    };
  });

  return (
    <iframe
      className={styles.iFrame}
      ref={iframeRef}
      sandbox="allow-same-origin allow-scripts"
      src={src}
      title="athlete-card-iframe"
    />
  );
};

export default ProspectCardIFrame;
